import { api } from './api';

/**
 * Sesión G (Iter 41.17) — TalentCheck recruitment pipeline.
 * Admin + client surface APIs.
 */
export const recruitmentAdminApi = {
  list: (params = {}) =>
    api.get('/admin/recruitment-processes', { params }).then((r) => r.data),
  get: (id) => api.get(`/admin/recruitment-processes/${id}`).then((r) => r.data),
  create: (body) => api.post('/admin/recruitment-processes', body).then((r) => r.data),
  sendIntake: (id) =>
    api.post(`/admin/recruitment-processes/${id}/send-intake`).then((r) => r.data),
  approve: (id) =>
    api.post(`/admin/recruitment-processes/${id}/approve`).then((r) => r.data),
  addCandidates: (id, assignment_ids) =>
    api.post(`/admin/recruitment-processes/${id}/add-candidates`, { assignment_ids })
      .then((r) => r.data),
  addNote: (id, body) =>
    api.post(`/admin/recruitment-processes/${id}/notes`, { body }).then((r) => r.data),
  close: (id, reason) =>
    api.post(`/admin/recruitment-processes/${id}/close`, { reason }).then((r) => r.data),
  // Sprint TC-A.1 — atomically create assignments + link them to the process.
  // Payload: { questionnaire_ids, user_ids?, invite_emails? }
  // Returns: { created, skipped, invited, errors, process }
  spawnCandidates: (id, payload) =>
    api.post(`/admin/recruitment-processes/${id}/spawn-candidates`, payload).then((r) => r.data),
  // Sprint TC-A.3 — set / update a per-candidate decision. Payload:
  //   { candidate_user_id, status, note? } where status ∈ {shortlisted,
  //   continue_process, on_hold, rejected, hired}
  setDecision: (id, payload) =>
    api.post(`/admin/recruitment-processes/${id}/decisions`, payload).then((r) => r.data),
  // Sprint A · G-1 — Named candidate roster (HM admin / advisor).
  listCandidates: (id) =>
    api.get(`/admin/recruitment-processes/${id}/candidates`).then((r) => r.data),
  // Sprint TC-C.1 — side-by-side comparison of 2-4 selected candidates.
  // `aids` is an array of assignment_ids.
  compare: (id, aids) =>
    api
      .get(`/admin/recruitment-processes/${id}/comparison`, {
        params: { aids: (aids || []).join(',') },
      })
      .then((r) => r.data),
  // Sprint TC-C.2 — per-candidate shortlist toggle (advisor-only).
  toggleShortlist: (id, candidate_user_id, shortlisted) =>
    api
      .post(`/admin/recruitment-processes/${id}/shortlist`, {
        candidate_user_id, shortlisted,
      })
      .then((r) => r.data),
  // Sprint TC-D.1 — unified read-only activity timeline.
  getActivity: (id) =>
    api.get(`/admin/recruitment-processes/${id}/activity`).then((r) => r.data),
};

export const recruitmentClientApi = {
  list: () => api.get('/client/recruitment-processes').then((r) => r.data),
  get: (id) => api.get(`/client/recruitment-processes/${id}`).then((r) => r.data),
  submitIntake: (id, body) =>
    api.post(`/client/recruitment-processes/${id}/intake`, body).then((r) => r.data),
  // Sprint A · G-1 — Named candidate roster (client_admin / client_hr).
  listCandidates: (id) =>
    api.get(`/client/recruitment-processes/${id}/candidates`).then((r) => r.data),
  // Sprint TC-D.2 — Client TalentCheck workspace (kpis + enriched processes).
  workspace: () =>
    api.get('/client/recruitment-workspace').then((r) => r.data),
  // Sprint TC-D.2 — Client-safe activity timeline (strips advisor-only kinds).
  getActivity: (id) =>
    api.get(`/client/recruitment-processes/${id}/activity`).then((r) => r.data),
};
